export const background_styles = [
  {
    key: 'background',
    style_group: 'backgrounds',
    value: '',
    type: 'color',
    title: 'Background',
    is_required: false,
  },
  {
    key: 'background_image_url',
    style_group: 'backgrounds',
    title: 'Background Image',
    type: 'image',
    value: '',
    is_required: false,
  },
]
